import { createContext, useContext } from 'react';

interface NavigationContextType {
  onItemClick?: () => void;
  currentDepth: number;
}

export const NavigationContext = createContext<NavigationContextType>({
  currentDepth: 0,
});

export const useNavigation = () => useContext(NavigationContext);
